export function validateEmail(email) {
  if (typeof email !== 'string' || email.length > 254) {
    return false;
  }

  // Allow the characters permitted in an email local part by the spec
  // (letters, numbers and ! # $ % & ' * + / = ? ^ _ ` { | } ~ . -), e.g.
  // "a+b@gmail.com", while rejecting a leading dot, a trailing dot before the
  // @, and consecutive dots. The domain allows letters, numbers, hyphens and
  // dots, with a TLD of at least two letters.
  const emailRegex = /^(?!\.)(?!.*\.\.)[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(?<!\.)@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}

export const lowerHere = (str) => str.match(/[a-z]/);
export const upperHere = (str) => str.match(/[A-Z]/);
export const numberHere = (str) => str.match(/[0-9]/);

const specialChars = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
export const specialHere = (str) => str.match(specialChars);

export const checkIfApplePayIsAvailable = () => window.ApplePaySession && window.ApplePaySession.canMakePayments();
